import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {
  CreatePayLinkDto,
  FormSelectModelDto,
  PayLinksModelDto,
  PaymentType,
  VistualPosCurrency
} from "../../models/paylinks.model";
import {CheckItem} from "../../../../components/checkbox-block/checkbox-block.component";
import {ModalService} from "../../../../services/modal.service";
import {PaymentLinksDataService} from "../../services/payment-links-data.service";
import {DatePipe} from "@angular/common";
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {PaylinkUpdateDataService} from "../../services/paylink-update-data.service";
import {PaymentViewDataService} from "../../../payment-view-list/services/payment-view-data.service";

@Component({
  selector: "app-edit-paylink-dialog",
  templateUrl: "./edit-paylink-dialog.component.html",
  styleUrls: ["./edit-paylink-dialog.component.scss"],
})
export class EditPaylinkDialogComponent implements OnInit, OnDestroy {
  @Input() currenciesList: VistualPosCurrency[] = [];
  @Input() paylinkTypesList: FormSelectModelDto[] = [];
  @Input() virtualPosList: FormSelectModelDto[] = [];

  @Output() editedLink: EventEmitter<string> = new EventEmitter<string>();

  checkboxEmail: CheckItem = {name: "SEND_TO_EMAIL", state: false, id: 0};
  checkboxActiveLink: CheckItem = {name: "ACTIVE_LINK", state: false, id: 1};
  checkboxOnce: CheckItem = {name: "ONCE_PAYMENT", state: false, id: 2};
  selectedCurrency: VistualPosCurrency | null = null;

  isSending = false;

  isInitData = false;

  isInit = false;

  verticalPosition: "left" | "right" = "left";

  form!: FormGroup;

  paymentTypeList: FormSelectModelDto[] = [];

  subs: Subscription[] = [];

  searchResult: PaymentType | undefined;

  token = "";

  minCountSymbolForSearch = 0;

  constructor(
    private modalService: ModalService,
    private paymentLinkDataService: PaymentLinksDataService,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private paylinkUpdateDataService: PaylinkUpdateDataService,
    private paymentViewDataService: PaymentViewDataService
  ) {
  }

  ngOnInit() {
    this.initForm();
    this.initUpdateForm();
    this.isInit = true;
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
  }

  initUpdateForm() {
    this.subs.push(
      this.paylinkUpdateDataService.paymentLinkDetail$.subscribe({
        next: (res) => {
          if (res) {
            this.initFormEdit(res);
          }
        },
      })
    );

    this.subs.push(
      this.modalService.isModalOpen$.subscribe({
        next: (res) => {
          if (!res && this.isInit) {
            this.isInitData = false;
          }
        },
      })
    );
  }

  get emailFields() {
    return this.form.controls["emailFields"] as FormArray;
  }

  setCurrency(virtualPos: FormSelectModelDto) {
    this.selectedCurrency = this.currenciesList.filter((el) => el.vp_id === virtualPos.value)[0];
  }

  addEmailFields() {
    const addFieldForm = this.formBuilder.group({
      email: ["", [Validators.email, Validators.required]],
    });

    this.emailFields.push(addFieldForm);
  }

  deleteEmailField(i: number) {
    this.emailFields.removeAt(i);

    if (!this.emailFields.length) {
      this.checkboxEmail.state = false;
    }
  }

  getFormGroup(control: AbstractControl) {
    return control as FormGroup;
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl("", Validators.required),
      sum: new FormControl("", Validators.required),
      type: new FormControl("", Validators.required),
      pos: new FormControl("", Validators.required),
      orderNumber: new FormControl(""),
      fullName: new FormControl(""),
      dateFrom: new FormControl("", Validators.required),
      dateTo: new FormControl(""),
      paymentType: new FormControl("", Validators.required),
      webhook_url: new FormControl(""),
      emailFields: this.formBuilder.array([]),
    });
  }

  get nameRequiredError() {
    return this.form.get("name")?.hasError("required");
  }

  get sumRequiredError() {
    return this.form.get("sum")?.hasError("required");
  }

  get currencyError(): string {
    if (this.form.get("currency")?.hasError("required") && this.form.get("currency")?.touched) {
      return "PAYMENT_LINK_PAGE.ERROR.CURRENCY_REQUIRED";
    } else {
      return "";
    }
  }

  get typeError(): string {
    if (this.form.get("type")?.hasError("required") && this.form.get("type")?.touched) {
      return "PAYMENT_LINK_PAGE.ERROR.TYPE_REQUIRED";
    } else {
      return "";
    }
  }

  get posError(): string {
    if (this.form.get("pos")?.hasError("required") && this.form.get("pos")?.touched) {
      return "PAYMENT_LINK_PAGE.ERROR.POS_REQUIRED";
    } else {
      return "";
    }
  }

  get dateFromError(): string {
    if (this.form.get("dateFrom")?.hasError("required") && this.form.get("dateFrom")?.touched) {
      return "PAYMENT_LINK_PAGE.ERROR.DATE_FROM_REQUIRED";
    } else {
      return "";
    }
  }

  get paymentTypeError(): string {
    if (this.form.get("paymentType")?.hasError("required") && this.form.get("paymentType")?.touched) {
      return "PAYMENT_LINK_PAGE.ERROR.PAYMENT_TYPE_REQUIRED";
    } else {
      return "";
    }
  }

  initFormEdit(data: PayLinksModelDto) {
    this.form.reset();
    (this.form.controls["emailFields"] as FormArray).clear();
    this.form.get("name")?.setValue(data.service_product_name);
    this.form.get("webhook_url")?.setValue(data.webhook_url);
    this.form.get("sum")?.setValue(data.amount);
    this.form.get("dateFrom")?.setValue(data.date_from);
    this.form.get("dateTo")?.setValue(data.date_to);
    this.form.get("orderNumber")?.setValue(data.invoice_id);
    this.form.get("fullName")?.setValue(data.full_name);
    this.form.get("type")?.setValue(data.paylink_type);
    this.form.get("pos")?.setValue(data.virtual_pos_id);
    this.form.get("paymentType")?.setValue(data.payment_type?.id);
    this.searchResult = data.payment_type;
    this.checkboxEmail.state = data.is_send_by_email;
    this.checkboxActiveLink.state = !data.is_blocked;
    this.checkboxOnce.state = data.is_single_payment === "SINGLE";

    this.token = data.token;

    if (data.email.length === 0) {
      this.checkboxEmail.state = false;
    }

    if (this.checkboxEmail.state) {
      for (let i = 0; i < data.email.length; i++) {
        const emailFields = this.formBuilder.group({
          email: [data.email[i], [Validators.required, Validators.email]],
        });
        this.emailFields.push(emailFields);
      }
    }
    this.setCurrency(this.virtualPosList.filter((el) => el.value === data.virtual_pos_id)[0]);
    this.isInitData = true;
  }

  closeModal() {
    this.modalService.closeModal();
  }

  sendPaylinkData() {
    if (!this.form.get("paymentType")?.value) {
      return;
    }
    this.isSending = true;
    let type: string;
    if (this.checkboxOnce.state) {
      type = "SINGLE";
    } else {
      type = "MULTIPLE";
    }

    const dateFrom = `${this.datePipe.transform(this.form.get("dateFrom")!.value, "dd-MM-YYYY HH:mm:ss")}`;

    const dateTo = this.form.get("dateTo")?.value ? `${this.datePipe.transform(this.form.get("dateTo")?.value, "dd-MM-YYYY HH:mm:ss")}` : "";

    const mailArray: string[] = [];

    for (let i = 0; i < (this.form.controls["emailFields"] as FormArray).length; i++) {
      mailArray.push((this.form.controls["emailFields"] as FormArray).controls[i].get("email")?.value);
    }

    const payLinkData: CreatePayLinkDto = {
      amount: +this.form.get("sum")!.value,
      currency: this.selectedCurrency?.currency!,
      email: mailArray,
      date_from: dateFrom,
      date_to: dateTo,
      full_name: this.form.get("fullName")?.value,
      virtual_pos_name: this.virtualPosList.find((item) => item.value === this.form.get("pos")?.value)?.description ?? "",
      virtual_pos_id: this.form.get("pos")?.value,
      payment_type_id: this.form.get("paymentType")?.value.id ?? this.searchResult?.id,
      paylink_type: this.form.get("type")?.value,
      is_send_by_email: this.checkboxEmail.state,
      is_single_payment: type,
      service_product_name: this.form.get("name")?.value,
      invoice_id: this.form.get("orderNumber")?.value,
      webhook_url: this.form.get("webhook_url")?.value,
      is_blocked: !this.checkboxActiveLink.state,
    };

    this.paymentLinkDataService.editPaylink(payLinkData, this.token).subscribe({
      next: () => {
        this.editedLink.next(this.token);
        this.isSending = false;
      },
      error: () => {
        this.isSending = false;
      },
    });
  }

  changeEmailCheck(check: CheckItem) {
    if (check.state) {
      this.addEmailFields();
    } else {
      let i = (this.form.controls["emailFields"] as FormArray).length;
      while (i !== 0) {
        (this.form.controls["emailFields"] as FormArray).removeAt(i - 1);
        i--;
      }
    }
  }

  searchEvent(word: string) {
    this.paymentViewDataService.loadSearchPaymentTypeList(word).subscribe({
      next: (res) => {
        this.paymentTypeList = res.content;
      },
    })
  }
}
